import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../templates/sidebar";
import Topbar from "../templates/topbar";
import OffreServices from "../../services/offre/offreServices";
import offreInterface from "../../models/offre.interface";

function CreateOrUpdateOffre() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({ ...offreInterface });
  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    if (id) {
      OffreServices.getOne(id)
        .then((res) => {
          if (res.data) {
            console.log("Entreprise récupéré avec succès :", res.data.data);
            setFormData(res.data.data);
          }
        })
        .catch((err) => {
          console.error(
            "Erreur lors de la récupération de l'entreprise :",
            err
          );
          setMessage({
            type: "error",
            text: "Erreur lors du chargement des données.",
          });
        });
    } else {
      setFormData({
        designation: "",
        prixMois: 0,
        prixAnnee: 0,
        access: [""],
      });
    }
  }, [id]);

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const dataToSend = {
      ...formData,
      prixMois: Number(formData.prixMois),
      prixAnnee: Number(formData.prixAnnee),
    };
  
    console.log(dataToSend);
  
    if (id) {
      try {
        await OffreServices.update(id, dataToSend);
        console.log("✅ Offre mis à jour avec succès !");
        setMessage({ type: "success", text: "Offre mis à jour avec succès !" });
        setTimeout(() => navigate("/offres"), 2000);
      } catch (err) {
        console.error("Erreur lors de la mise à jour :", err);
        setMessage({ type: "error", text: "Erreur lors de la mise à jour." });
      }
    } else {
      try {
        await OffreServices.create(dataToSend);
        console.log("✅ Offre créé avec succès !");
        setMessage({ type: "success", text: "Offre créé avec succès !" });
        setTimeout(() => navigate("/offres"), 2000);
      } catch (err) {
        console.error("Erreur création Offre :", err);
  
        if (err.response?.data?.message) {
          setError(err.response.data.message);
        } else {
          setError("Une erreur est survenue. Veuillez réessayer.");
        }
      }
    }
  };
  

  return (
    <div className="full_container">
      <div className="inner_container">
        <Sidebar />
        <div id="content">
          <Topbar />
          <div className="middle_content">
            <div className="container-fluid">
              <div className="row column_title">
                <div className="col-md-12">
                  <div className="page_title">
                    <h2>Offre</h2>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="white_shd full margin_bottom_30">
                  <div className="full graph_head">
                    <div className="heading1 margin_0">
                      <h2>{id ? "Modifier l'offre" : "Créer un entreprise"}</h2>
                    </div>
                  </div>
                  <div className="form_section padding_infor_info">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <label>Désignation</label>
                        <input
                          type="text"
                          value={formData.designation || ""}
                          name="designation"
                          className="form-control"
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Prix/Mois</label>
                        <input
                          type="number"
                          value={formData.prixMois || 0}
                          name="prixMois"
                          className="form-control"
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Prix/Année</label>
                        <input
                          type="number"
                          value={formData.prixAnnee || 0}
                          name="prixAnnee"
                          className="form-control"
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Accès</label>
                        {formData.access.map((item, index) => (
                          <div key={index} className="d-flex mb-2">
                            <input
                              type="text"
                              className="form-control mr-2"
                              value={item}
                              onChange={(e) => {
                                const newAcces = [...formData.access];
                                newAcces[index] = e.target.value;
                                setFormData({ ...formData, access: newAcces });
                              }}
                              required
                            />
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => {
                                const newAcces = formData.access.filter(
                                  (_, i) => i !== index
                                );
                                setFormData({ ...formData, access: newAcces });
                              }}
                            >
                              -
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            setFormData({
                              ...formData,
                              access: [...formData.access, ""],
                            });
                          }}
                        >
                          + Ajouter un accès
                        </button>
                      </div>

                      <button type="submit" className="btn btn-success">
                        {id ? "Enregistrer" : "Créer"}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateOrUpdateOffre;
